import { generateId } from 'ai';

/**
 * Creates an ID mapper for mapping local IDs to persistent UUIDs.
 * Used for thread IDs to ensure consistency across the app lifecycle.
 */
export function createIdMapper() {
  const idToUuidMap = new Map<string, string>();

  return {
    /** Gets existing UUID or creates new one for the given ID. */
    getOrCreate(id: string): string {
      const existing = idToUuidMap.get(id);
      if (existing) return existing;

      const uuid = generateId();
      idToUuidMap.set(id, uuid);
      return uuid;
    },

    /** Gets the UUID for an ID, or null if not found. */
    get(id: string): string | null {
      return idToUuidMap.get(id) ?? null;
    },
  };
}
